<template>
  <div>
    <form @submit.prevent="onSubmit()">
      <div class="row">
        <div class="mb-3">
          <label class="form-label mandatory" for="text">Title</label>
          <textarea
            rows="2"
            wrap="soft"
            id="title"
            v-model="reqObj.title"
            :maxlength="50"
            placeholder="Enter Title"
            class="form-control"
            required
          ></textarea>
          <div class="text-muted small text-end mt-1">
            {{ reqObj.title.length }}/50
          </div>
        </div>
        <div class="">
          <label class="form-label mandatory" for="title">Text</label>
          <textarea
            rows="2"
            wrap="soft"
            id="text"
            v-model="reqObj.text"
            :maxlength="150"
            placeholder="Enter Text"
            class="form-control"
            required
          ></textarea>
          <div class="text-muted small text-end mt-1">
            {{ reqObj.text.length }}/150
          </div>
        </div>
      </div>
      <div class="text-end mt-4">
        <button class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
import user from "@/ajax/user";
import UnauthorizedPage from "@/views/Layouts/UnauthorizedPage.vue";
import myMixin from "@/mixins/Permission";

export default {
  components: { Datepicker, UnauthorizedPage },
  mixins: [myMixin],
  props: ["editData"],
  data() {
    return {
      permissions: window.localStorage.getItem("permissions"),
      reqObj: {
        title: "",
        text: "",
      },
      editid: 0,
    };
  },
  mounted() {
    $("#notificationModal").on("hidden.bs.modal", this.resetForm);
    if (this.permissions.includes("notifications.create")) {
      this.getUserPermissions();
    }
  },
  methods: {
    ...mapActions("userStore", ["setCurrentUser", "logoutUser"]),
    ...mapActions("common", ["setCurrentPage"]),

    resetForm() {
      this.reqObj.title = "";
      this.reqObj.text = "";
    },

    onSubmit() {
      if (!this.editData) {
        user
          .createNotification(this.reqObj)
          .then((result) => {
            if (result.data.code == 200) {
              Swal.fire({
                title: "Success",
                text: "Notification Added Successfully !!!",
                icon: "success",
                timer: 2500,
              });
              this.$emit("close-modal");
            } else {
              Swal.fire({
                title: "Error",
                text: "Failed to Add Notification !!!",
                icon: "error",
                timer: 2500,
              });
              this.$emit("close-modal");
            }
          })
          .catch((err) => {
            let message = "Something went wrong !!!";
            if (err.response) {
              if (err.response.data) {
                message = err.response.data.detail;
              }
            }
            Swal.fire({
              title: "Error",
              text: message,
              icon: "error",
              timer: 2500,
            });
            this.$emit("close-modal");
          });
      } else {
        const reqObj = {
          title: this.reqObj.title,
          text: this.reqObj.text,
        };
        user
          .updateNotification(this.editData.id, reqObj)
          .then((result) => {
            if (result.data.code == 200) {
              Swal.fire({
                title: "Success",
                text: "Notification Updated Successfully !!!",
                icon: "success",
                timer: 2500,
              });
              this.$emit("close-modal");
            } else {
              Swal.fire({
                title: "Error",
                text: "Failed to Update Notification !!!",
                icon: "error",
                timer: 2500,
              });
              this.$emit("close-modal");
            }
          })
          .catch((err) => {
            let message = "Something went wrong !!!";
            if (err.response) {
              if (err.response.data) {
                message = err.response.data.detail;
              }
            }
            Swal.fire({
              title: "Error",
              text: message,
              icon: "error",
              timer: 2500,
            });
            this.$emit("close-modal");
          });
      }
    },
  },
  computed: {
    ...mapState("userStore", ["currentUser"]),
  },
  watch: {
    editData(nv, ov) {
      if (nv) {
        this.reqObj.title = nv.title;
        this.reqObj.text = nv.text;
      }
      if (!nv && ov) {
        this.reqObj.title = "";
        this.reqObj.text = "";
      }
    },
  },
};
</script>
